<nav
  class="scrollbar-hide flex h-full w-16 flex-col items-start gap-1 overflow-y-auto
    border-r border-surface-300 px-3 pt-2"
  [@expandColapseMainDrawer]="dashboardState.mainDrawer()"
  (mousedown)="onDragStart($event)"
  (mouseleave)="onDragEnd()"
  #navContainer>
  @for (
    menu of dashboardState.menus() | keyvalue: originalOrder;
    track $index
  ) {
    <div class="flex w-full flex-col gap-1">
      <!-- Splitted button -->
      <div class="flex h-10 grow overflow-hidden rounded-md">
        <button
          (click)="clickAction(menu.value)"
          class="flex grow items-center gap-[9px] p-2"
          [class]="
            isMenuOrSubitemActive(menu.value) ? 'selected' : 'not-selected'
          "
          [attr.analytics-label]="
            'menu/' +
            menu.value.label.toLowerCase().replaceAll(' ', '_') +
            '/item'
          ">
          <span
            class="flex flex-row items-center"
            [class.text-secondary-700]="isMenuOrSubitemActive(menu.value)">
            <ng-icon [name]="menu.value.icon" class="min-w-6 text-2xl" />
          </span>
          <span class="whitespace-nowrap text-surface-900">
            {{ menu.value.label }}
          </span>
        </button>
        @if (menu.value.subitems.length > 0) {
          <button
            (click)="dashboardState.menus.toggle(menu.key + '.open')"
            class="flex min-w-10 items-center justify-center p-2"
            [class]="
              isMenuOrSubitemActive(menu.value) ? 'selected' : 'not-selected'
            "
            [attr.analytics-label]="
              'menu/' +
              menu.value.label.toLowerCase().replaceAll(' ', '_') +
              '/toggle'
            ">
            <ng-icon
              name="phosphorCaretDown"
              [@rotate90Clockwise]="menu.value.open" />
          </button>
        }
      </div>

      <!-- Menu items -->
      <ul
        class="flex w-full flex-col gap-1 overflow-hidden pl-4"
        [@expandColapseVertical]="menu.value.open">
        @for (subitem of menu.value.subitems; track $index) {
          <li>
            <button
              class="flex min-h-9 w-full cursor-pointer items-center justify-start gap-2 rounded-lg
                px-3 text-surface-700"
              [class]="
                appState.isRouteActive([subitem.path])
                  ? 'selected'
                  : 'not-selected'
              "
              [routerLink]="[subitem.path]"
              [attr.analytics-label]="
                'menu/' +
                menu.value.label.toLowerCase().replaceAll(' ', '_') +
                '/subitem/' +
                subitem.label.toLowerCase().replaceAll(' ', '_')
              ">
              <span
                class="flex flex-row items-center"
                [class.text-secondary-700]="
                  appState.isRouteActive([subitem.path])
                ">
                <ng-icon [name]="subitem.icon" class="text-2xl" />
              </span>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap">
                {{ subitem.label }}
              </span>
            </button>
          </li>
        }
      </ul>
    </div>
    @if (menu.value.paintRow) {
      <div class="h-[1px] w-full bg-slate-200"></div>
    }
  }
</nav>
